// Firebase Configuration and Initialization
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getDatabase } from 'firebase/database'
import { getStorage } from 'firebase/storage'

// Firebase configuration
// Las credenciales se cargan desde variables de entorno (.env)
// IMPORTANTE: En Vue CLI, las variables deben tener el prefijo VUE_APP_ para estar disponibles
// Valores por defecto se mantienen para compatibilidad si no se configuran las variables
//
// Para configurar, agrega estas variables en tu archivo .env:
// VUE_APP_FIREBASE_API_KEY=tu_api_key
// VUE_APP_FIREBASE_AUTH_DOMAIN=tu_dominio
// VUE_APP_FIREBASE_DATABASE_URL=tu_url
// VUE_APP_FIREBASE_PROJECT_ID=tu_project_id
// VUE_APP_FIREBASE_STORAGE_BUCKET=tu_bucket
// VUE_APP_FIREBASE_MESSAGING_SENDER_ID=tu_sender_id
// VUE_APP_FIREBASE_APP_ID=tu_app_id
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY || 'AIzaSyAzzLkVz7Rsu0To5cSawdbDdLzgTnOCY7I',
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN || 'super-kompras.firebaseapp.com',
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL || 'https://super-kompras.firebaseio.com',
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID || 'super-kompras',
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET || 'super-kompras.appspot.com',
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID || '401245304429',
  appId: process.env.VUE_APP_FIREBASE_APP_ID || '1:401245304429:web:5fb7a84d417830ee53f164',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app)

// Initialize Realtime Database and get a reference to the service
export const database = getDatabase(app)

// Initialize Firebase Storage and get a reference to the service
export const storage = getStorage(app)

export default app
